import { render, staticRenderFns } from "./widget_portfolio_index.vue?vue&type=template&id=4fb6d938&scoped=true&"
import script from "./widget_portfolio_index.vue?vue&type=script&lang=js&"
export * from "./widget_portfolio_index.vue?vue&type=script&lang=js&"
import style0 from "./widget_portfolio_index.vue?vue&type=style&index=0&id=4fb6d938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6d938",
  null
  
)

export default component.exports